import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    text: {
        display: 'flex',
        gap: theme.spacing(1),
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100%',
        fontWeight: 600,
        fontSize: '1.2rem',
        color: theme.palette.primary.main,
        '& span': {
            fontWeight: 400,
            color: theme.palette.text.primary,
        },
    }
}))